import React from "react";

function NoFiles() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100%"
      data-name="Layer 1"
      viewBox="0 0 842 778.92"
    >
      <defs>
        <linearGradient
          id="a91ba363-77be-43f7-9cf6-91c4a3880d9c"
          x1="378.37"
          x2="378.37"
          y1="732.81"
          y2="130.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="gray" stopOpacity="0.25"></stop>
          <stop offset="0.54" stopColor="gray" stopOpacity="0.12"></stop>
          <stop offset="1" stopColor="gray" stopOpacity="0.1"></stop>
        </linearGradient>
        <linearGradient
          id="d1e6aa0e-d79d-4f6f-afbb-c37e9ed80ff9"
          x1="274.44"
          x2="274.44"
          y1="409.32"
          y2="248.16"
          xlinkHref="#a91ba363-77be-43f7-9cf6-91c4a3880d9c"
        ></linearGradient>
        <linearGradient
          id="a279b039-1afd-4281-8292-ccd5c8c9b734"
          x1="274.44"
          x2="274.44"
          y1="361.44"
          y2="261.01"
          xlinkHref="#a91ba363-77be-43f7-9cf6-91c4a3880d9c"
        ></linearGradient>
        <clipPath
          id="42e7b1d1-2be2-47b0-aacb-a853df270819"
          transform="translate(-179 -60.54)"
        >
          <path
            fill="#fff"
            d="M381.54 322.72H525.33V419.65000000000003H381.54z"
            data-name="&lt;Rectangle&gt;"
          ></path>
        </clipPath>
        <linearGradient
          id="972637f2-71db-4198-9c75-a0854a7fe249"
          x1="274.44"
          x2="274.44"
          y1="616.03"
          y2="454.87"
          xlinkHref="#a91ba363-77be-43f7-9cf6-91c4a3880d9c"
        ></linearGradient>
        <linearGradient
          id="6c85befd-f960-412c-83e0-663d4b13bf85"
          x1="274.44"
          x2="274.44"
          y1="568.15"
          y2="467.72"
          xlinkHref="#a91ba363-77be-43f7-9cf6-91c4a3880d9c"
        ></linearGradient>
        <clipPath
          id="f66b8fac-771d-49bf-85c7-4ce29a79f723"
          transform="translate(-179 -60.54)"
        >
          <path
            fill="#fff"
            d="M381.54 529.42H525.33V626.3499999999999H381.54z"
            data-name="&lt;Rectangle&gt;"
          ></path>
        </clipPath>
        <linearGradient
          id="598f8edf-c762-4b18-b52d-250fc678075a"
          x1="688.76"
          x2="688.76"
          y1="765.86"
          y2="163.26"
          gradientTransform="rotate(90 665.375 476.845)"
          xlinkHref="#a91ba363-77be-43f7-9cf6-91c4a3880d9c"
        ></linearGradient>
        <linearGradient
          id="013b841e-9a42-49b8-8a36-6db9ed002b72"
          x1="688.18"
          x2="688.18"
          y1="568.49"
          y2="409.67"
          gradientTransform="rotate(90 662.7 498.69)"
          xlinkHref="#a91ba363-77be-43f7-9cf6-91c4a3880d9c"
        ></linearGradient>
        <linearGradient
          id="f8cab3c1-d868-48bc-b87d-cd2075ddc26a"
          x1="810.6"
          x2="810.6"
          y1="767.54"
          y2="362.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#b3b3b3" stopOpacity="0.25"></stop>
          <stop offset="0.54" stopColor="#b3b3b3" stopOpacity="0.1"></stop>
          <stop offset="1" stopColor="#b3b3b3" stopOpacity="0.05"></stop>
        </linearGradient>
        <linearGradient
          id="043d467e-585e-47c7-bb2c-06dd6f5be04b"
          x1="685.49"
          x2="685.49"
          y1="507.08"
          y2="487.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopOpacity="0.12"></stop>
          <stop offset="0.55" stopOpacity="0.09"></stop>
          <stop offset="1" stopOpacity="0.02"></stop>
        </linearGradient>
        <linearGradient
          id="be08032f-102d-431e-9b5f-1e4ebfc8159b"
          x1="774.99"
          x2="774.99"
          y1="484.73"
          y2="425.15"
          xlinkHref="#043d467e-585e-47c7-bb2c-06dd6f5be04b"
        ></linearGradient>
      </defs>
      <path
        fill="url(#a91ba363-77be-43f7-9cf6-91c4a3880d9c)"
        d="M154.15 130.21H602.59V732.8100000000001H154.15z"
        opacity="0.5"
      ></path>
      <path
        fill="#f2f2f2"
        d="M159.99 138.39H594.4200000000001V719.97H159.99z"
      ></path>
      <path
        fill="#e0e0e0"
        d="M193.86 162.91H343.34000000000003V167.57999999999998H193.86z"
      ></path>
      <path
        fill="#0a80ff"
        d="M193.86 183.93H343.34000000000003V188.6H193.86z"
        opacity="0.7"
      ></path>
      <path
        fill="#e0e0e0"
        d="M365.53 162.91H515.01V167.57999999999998H365.53z"
      ></path>
      <path fill="#e0e0e0" d="M388.88 296.05H538.36V300.72H388.88z"></path>
      <path fill="#e0e0e0" d="M392.39 308.89H541.87V313.56H392.39z"></path>
      <path fill="#e0e0e0" d="M399.4 321.74H548.88V326.41H399.4z"></path>
      <path fill="#e0e0e0" d="M388.88 502.75H538.36V507.42H388.88z"></path>
      <path fill="#e0e0e0" d="M392.39 515.6H541.87V520.27H392.39z"></path>
      <path fill="#e0e0e0" d="M399.4 528.44H548.88V533.11H399.4z"></path>
      <path
        fill="url(#d1e6aa0e-d79d-4f6f-afbb-c37e9ed80ff9)"
        d="M195.03 248.16H353.85V409.32H195.03z"
        opacity="0.5"
      ></path>
      <path fill="#f5f5f5" d="M196.03 251.67H352.35V405.82H196.03z"></path>
      <path
        fill="url(#a279b039-1afd-4281-8292-ccd5c8c9b734)"
        d="M201.54 261.01H347.34000000000003V361.44H201.54z"
        opacity="0.5"
      ></path>
      <path
        fill="#fff"
        d="M202.54 262.18H346.33V359.11H202.54z"
        data-name="&lt;Rectangle&gt;"
      ></path>
      <g fill="#0a80ff" clipPath="url(#42e7b1d1-2be2-47b0-aacb-a853df270819)">
        <path
          d="M190.35 355.61L226.56 299.55 241.74 324.07 274.44 290.21 302.47 324.07 326.99 273.86 390.05 374.29 185.68 367.28 190.35 355.61z"
          opacity="0.4"
        ></path>
        <circle cx="218.38" cy="276.19" r="10.51" opacity="0.4"></circle>
      </g>
      <path
        fill="url(#972637f2-71db-4198-9c75-a0854a7fe249)"
        d="M195.03 454.87H353.85V616.03H195.03z"
        opacity="0.5"
      ></path>
      <path fill="#f5f5f5" d="M196.03 458.37H352.35V612.52H196.03z"></path>
      <path
        fill="url(#6c85befd-f960-412c-83e0-663d4b13bf85)"
        d="M201.54 467.72H347.34000000000003V568.1500000000001H201.54z"
        opacity="0.5"
      ></path>
      <path
        fill="#fff"
        d="M202.54 468.88H346.33V565.81H202.54z"
        data-name="&lt;Rectangle&gt;"
      ></path>
      <g fill="#bdbdbd" clipPath="url(#f66b8fac-771d-49bf-85c7-4ce29a79f723)">
        <path
          d="M190.35 562.31L226.56 506.25 241.74 530.78 274.44 496.91 302.47 530.78 326.99 480.56 390.05 580.99 185.68 573.99 190.35 562.31z"
          opacity="0.4"
        ></path>
        <circle cx="218.38" cy="482.9" r="10.51" opacity="0.4"></circle>
      </g>
      <path
        fill="url(#598f8edf-c762-4b18-b52d-250fc678075a)"
        d="M376.36 276.01H978.96V724.45H376.36z"
        opacity="0.5"
        transform="rotate(-78.76 551.253 578.999)"
      ></path>
      <path
        fill="#fff"
        d="M386.18 280.49H967.76V714.9200000000001H386.18z"
        transform="rotate(-78.76 550.568 576.479)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M542.89 232.65H851.2V237.32H542.89z"
        transform="rotate(11.24 915.316 -704.735)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M456.83 665.62H765.14V670.29H456.83z"
        transform="rotate(11.24 829.21 -271.676)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M452.26 685.13H690.5V689.8H452.26z"
        transform="rotate(11.24 789.625 -252.184)"
      ></path>
      <path
        fill="#0a80ff"
        d="M448.46 696.91H537.21V701.5799999999999H448.46z"
        opacity="0.7"
        transform="rotate(11.24 711.059 -240.4)"
      ></path>
      <path
        fill="#0a80ff"
        d="M539.13 243.97H693.28V248.64H539.13z"
        opacity="0.7"
        transform="rotate(11.24 834.445 -693.443)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M532.71 282.38H810.6500000000001V287.05H532.71z"
        transform="rotate(11.24 889.943 -654.988)"
      ></path>
      <path
        fill="#3ad29f"
        d="M529.49 288.24H597.22V292.91H529.49z"
        opacity="0.7"
        transform="rotate(11.24 781.6 -649.15)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M521.95 338.03H830.26V342.7H521.95z"
        transform="rotate(11.24 894.34 -599.346)"
      ></path>
      <path
        fill="url(#013b841e-9a42-49b8-8a36-6db9ed002b72)"
        d="M592.89 385.78H751.71V662.55H592.89z"
        opacity="0.5"
        transform="rotate(-78.76 545.898 602.937)"
      ></path>
      <path
        fill="#fff"
        d="M535.78 445.94H809.05V601.26H535.78z"
        transform="rotate(11.24 890.673 -416.089)"
      ></path>
      <path
        fill="#e0e0e0"
        d="M516.71 364.38H825.02V369.05H516.71z"
        transform="rotate(11.24 889.087 -572.972)"
      ></path>
      <path
        fill="#0a80ff"
        d="M566.14 449.2H600.01V562.48H566.14z"
        transform="rotate(11.24 801.302 -433.818)"
      ></path>
      <path
        fill="#3ad29f"
        d="M622.06 498.05H655.93V573.96H622.06z"
        transform="rotate(11.24 857.214 -403.665)"
      ></path>
      <path
        fill="#f55f44"
        d="M678.21 544.59H712.08V585.46H678.21z"
        transform="rotate(11.24 913.377 -374.613)"
      ></path>
      <path
        fill="#fdd835"
        d="M741.87 514.79H775.74V597.7099999999999H741.87z"
        transform="rotate(11.24 977.053 -383.393)"
      ></path>
      <path
        fill="url(#f8cab3c1-d868-48bc-b87d-cd2075ddc26a)"
        d="M880.45 410.55a155.89 155.89 0 00-223.11-1.68c-59 59.48-60 156.33-2.29 217.07A155.89 155.89 0 00854.95 648l112.69 117.21a7.59 7.59 0 0010.73.21l28.08-27a7.59 7.59 0 00.21-10.73L894 610.49a155.9 155.9 0 00-13.55-199.94zM845.35 599a111.5 111.5 0 113.1-157.66 111.5 111.5 0 01-3.1 157.66z"
        transform="translate(-179 -60.54)"
      ></path>
      <path
        fill="url(#043d467e-585e-47c7-bb2c-06dd6f5be04b)"
        d="M685.49 487.6c-12.54 0-12.56 19.49 0 19.49s12.56-19.49 0-19.49z"
        transform="translate(-179 -60.54)"
      ></path>
      <path
        fill="url(#be08032f-102d-431e-9b5f-1e4ebfc8159b)"
        d="M772.9 425.17c-33.75-.76-64.46 16.17-80.79 41.73-5.33 8.34 9.8 15.71 15.1 7.41 13.52-21.16 39.21-34.6 67-33.9 29.12.73 55.62 17.39 69.65 40.51 5.32 8.77 19.27.8 14-7.92-17.06-28-50.1-47-84.96-47.83z"
        transform="translate(-179 -60.54)"
      ></path>
      <path
        fill="#0a80ff"
        d="M892.68 404.63a155.89 155.89 0 00-223.11-1.68c-59 59.48-60 156.33-2.29 217.07a155.89 155.89 0 00199.9 22.05l112.68 117.22a7.59 7.59 0 0010.73.21l28.08-27a7.59 7.59 0 00.21-10.73L906.19 604.56a155.9 155.9 0 00-13.51-199.93zM857.58 593a111.5 111.5 0 113.1-157.66 111.5 111.5 0 01-3.1 157.66z"
        transform="translate(-179 -60.54)"
      ></path>
      <path
        fill="#0a80ff"
        d="M697.72 481.67c-12.54 0-12.56 19.49 0 19.49s12.56-19.49 0-19.49zM785.13 419.25c-33.75-.76-64.46 16.17-80.79 41.73-5.33 8.34 9.8 15.71 15.1 7.41 13.52-21.16 39.21-34.6 67-33.9 29.12.73 55.62 17.39 69.65 40.51 5.32 8.77 19.27.8 14-7.92C853 439 820 420 785.13 419.25z"
        transform="translate(-179 -60.54)"
      ></path>
      <path fill="#47e6b1" d="M121.45 663.91H124.95V683.76H121.45z"></path>
      <path
        fill="#47e6b1"
        d="M300.45 724.45H303.95V744.3000000000001H300.45z"
        transform="rotate(90 242.975 614.605)"
      ></path>
      <path
        fill="#4d8af0"
        d="M750.87 68.49a4.29 4.29 0 01-2.39-5.19 2.06 2.06 0 00.09-.48 2.15 2.15 0 00-3.87-1.43 2.06 2.06 0 00-.24.42 4.29 4.29 0 01-5.19 2.39 2.06 2.06 0 00-.48-.09 2.15 2.15 0 00-1.41 3.89 2.06 2.06 0 00.42.24 4.29 4.29 0 012.39 5.19 2.06 2.06 0 00-.09.48 2.15 2.15 0 003.9 1.41 2.06 2.06 0 00.24-.42 4.29 4.29 0 015.19-2.39 2.06 2.06 0 00.48.09 2.15 2.15 0 001.43-3.87 2.06 2.06 0 00-.47-.24z"
        transform="translate(-179 -60.54)"
      ></path>
      <path
        fill="#fdd835"
        d="M316.44 215.64a4.29 4.29 0 01-2.39-5.19 2.06 2.06 0 00.09-.48 2.15 2.15 0 00-3.87-1.43 2.06 2.06 0 00-.24.42 4.29 4.29 0 01-5.19 2.39 2.06 2.06 0 00-.48-.09 2.15 2.15 0 00-1.43 3.87 2.06 2.06 0 00.42.24 4.29 4.29 0 012.39 5.19 2.06 2.06 0 00-.09.48 2.15 2.15 0 003.87 1.43 2.06 2.06 0 00.24-.42 4.29 4.29 0 015.19-2.39 2.06 2.06 0 00.48.09 2.15 2.15 0 001.43-3.87 2.06 2.06 0 00-.42-.24zM934.22 822.9a4.29 4.29 0 01-2.39-5.19 2.06 2.06 0 00.09-.48 2.15 2.15 0 00-3.87-1.43 2.06 2.06 0 00-.24.42 4.29 4.29 0 01-5.19 2.39 2.06 2.06 0 00-.48-.09 2.15 2.15 0 00-1.43 3.87 2.06 2.06 0 00.42.24 4.29 4.29 0 012.39 5.19 2.06 2.06 0 00-.09.48 2.15 2.15 0 003.87 1.43 2.06 2.06 0 00.24-.42 4.29 4.29 0 015.19-2.39 2.06 2.06 0 00.48.09 2.15 2.15 0 001.43-3.87 2.06 2.06 0 00-.42-.24z"
        transform="translate(-179 -60.54)"
      ></path>
      <circle cx="321.15" cy="75.33" r="7.01" fill="#f55f44"></circle>
      <circle cx="823.31" cy="162.91" r="7.01" fill="#f55f44"></circle>
      <circle cx="783.61" cy="371.95" r="7.01" fill="#4d8af0"></circle>
      <circle
        cx="7.01"
        cy="28.61"
        r="7.01"
        fill="#47e6b1"
        opacity="0.5"
      ></circle>
    </svg>
  );
}

export default NoFiles;
